export const MODAL_DIALOG__RESTORE_PASSWORD = 'MODAL_DIALOG__RESTORE_PASSWORD';
export const MODAL_DIALOG__RESET_PASSWORD = 'MODAL_DIALOG__RESET_PASSWORD';
